import React from 'react';
import { Box } from '@mui/material';
import ContactHero from './components/ContactHero';
import ContactForm from './components/ContactForm';
import Footer from '../../components/Footer';
import './Contact.css';

const Contact = () => {
  return (
    <Box className="contact-page">
      <ContactHero />
      <ContactForm />
      <Footer />
    </Box>
  );
};

export default Contact; 